import {Injectable} from '@angular/core';

import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ChatMessageAdapter} from './chat-message-adapter.service';
import * as moment from 'moment';
import {ChatNotification} from '../models/chat-notification.model';

@Injectable()
export class ChatNotificationAdapter implements IAdapter<ChatNotification> {
  constructor(private readonly chatMsgAdapter: ChatMessageAdapter) {}

  adaptToModel(resp: any): ChatNotification {
    const notif: ChatNotification = new ChatNotification();
    const msgLength = 150;
    Object.assign(notif, resp);
    if (resp.message) {
      notif.message = this.chatMsgAdapter.adaptToModel(resp.message);
      notif.messageBody = `${notif.message.body.substring(0, msgLength)}${
        notif.message.body.length > msgLength ? '....' : ''
      }`;
      notif.messageTitle = `${
        notif.message.sender ? notif.message.sender.fullName : ''
      } sent ${moment(new Date(notif.createdOn)).fromNow()}`;
    }
    notif.notificationTime = moment(new Date(notif.createdOn)).fromNow();
    return notif;
  }
  adaptFromModel(data: ChatNotification): any {
    const dataToSend = Object.assign({}, data);
    delete dataToSend.messageBody;
    delete dataToSend.notificationTime;
    delete dataToSend.messageTitle;
    return data;
  }
}
